import customTheme from '@/constants/theme.custom';
import { Box, Text } from '@cmpsr/components';

interface SubItem {
  content: JSX.Element;
}

interface Feature {
  content: JSX.Element;
  subItems?: SubItem[];
}

const FeatureList = () => {
  const features: Feature[] = [
    {
      content: (
        <>
          <Text as="span" fontWeight="bold">Lifetime risk scores for 21 major cancers</Text>
          <Text as="span"> based on 500+ validated risk factors</Text>
        </>
      )
    },
    {
      content: (
        <>
          <Text as="span" fontWeight="bold">Reduce your risk up to 60%</Text>
          <Text as="span"> with simple steps and targeted lifestyle interventions</Text>
        </>
      )
    },
    {
      content: (
        <>
          <Text as="span" fontWeight="bold">A personalized screening protocol</Text>
          <Text as="span"> based on your unique risk level for every cancer</Text>
        </>
      )
    },
    {
      content: (
        <>
          <Text as="span" fontWeight="bold">Coming soon </Text>
          <Text as="span">(no additional cost to Beta members)</Text>
        </>
      ),
      subItems: [
        {
          content: (
            <>
              <Text as="span">50+ </Text>
              <Text as="span" fontWeight="bold">blood biomarkers</Text>
              <Text as="span"> and </Text>
              <Text as="span" fontWeight="bold">wearables</Text>
              <Text as="span"> integration</Text>
            </>
          )
        },
        {
          content: (
            <>
              <Text as="span" fontWeight="bold">Heart disease</Text>
              <Text as="span"> and </Text>
              <Text as="span" fontWeight="bold">Alzheimer's Risk</Text>
            </>
          )
        }
      ]
    }
  ];

  return (
    <Box display="flex" flexDirection="column" gap="16px" width="100%" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      {features.map((feature, index) => (
        <Box key={index} display="flex" gap="12px" alignItems="flex-start">
          <Box
            width={{ base: "18px", md: "24px" }}
            height={{ base: "18px", md: "33px" }}
            flexShrink={0}
            mt={{ base: "3px", md: "2px" }}
            display="flex"
            alignItems="flex-start"
            justifyContent="center"
          >
            <img src="/images/checkmark-vector.svg" alt="" width="21" height="33" />
          </Box>
          <Box display="flex" flexDirection="column" gap="8px" width="100%">
            <Text
              fontSize="14px"
              color="darkBlue"
              fontFamily={customTheme.typography.fonts.inter}
              lineHeight="1.4"
            >
              {feature.content}
            </Text>
            {feature.subItems && (
              <Box display="flex" flexDirection="column" gap="6px" pl="8px">
                {feature.subItems.map((subItem, subIndex) => (
                  <Box key={subIndex} display="flex" gap="8px" alignItems="flex-start">
                    <Text
                      fontSize="14px"
                      color="darkBlue"
                      fontFamily={customTheme.typography.fonts.inter}
                      lineHeight="1.4"
                      flexShrink={0}
                    >
                      •
                    </Text>
                    <Text
                      fontSize="14px"
                      color="darkBlue"
                      fontFamily={customTheme.typography.fonts.inter}
                      lineHeight="1.4"
                    >
                      {subItem.content}
                    </Text>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FeatureList;
